module.exports = __webpack_public_path__ + "static/media/tp7.8404cf7c.jpg";